import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIsModalOpen, selectModalContent, selectModalContentProps, } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
const Modal = () => {
    const isOpen = useSelector(selectIsModalOpen);
    const contentKey = useSelector(selectModalContent);
    const contentProps = useSelector(selectModalContentProps);
    const modalRef = useRef(null);
    const previouslyFocusedElement = useRef(null);
    // Trap focus inside modal
    const handleKeyDown = (e) => {
        if (e.key !== 'Tab' || !modalRef.current)
            return;
        const focusableElements = modalRef.current.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
        const focusArray = Array.from(focusableElements);
        if (focusArray.length === 0)
            return;
        const firstElement = focusArray[0];
        const lastElement = focusArray[focusArray.length - 1];
        if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
        }
        else if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
        }
    };
    useEffect(() => {
        if (isOpen) {
            // Save the element that had focus before modal opened
            previouslyFocusedElement.current = document.activeElement;
            // Find first focusable element inside modal
            const firstFocusable = modalRef.current?.querySelector("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
            // Focus it
            firstFocusable?.focus();
        }
        else {
            // Restore focus when modal closes
            previouslyFocusedElement.current?.focus();
        }
    }, [isOpen]);
    if (!isOpen || contentKey === null) {
        return null;
    }
    const Content = MODAL_CONTENT[contentKey].component;
    return (_jsxs("div", { className: "modal", role: "dialog", "aria-modal": "true", children: [_jsx("div", { className: "modal-backdrop" }), _jsx("div", { ref: modalRef, className: "modal-panel", onKeyDown: handleKeyDown, children: _jsx(Content, { ...contentProps }) })] }));
};
export default Modal;
